export default "/assets/images/list-icon3.svg?dedcb0807113e1c2871a80e14497bb8a";